module.exports = __webpack_public_path__ + "img/selected0-min.7af44c19.png";